import React from "react";
import { Box, Typography } from "@mui/material";
import { QRCodeSVG } from "qrcode.react";
import DateWithUnderline from "./DateWithUnderline";
import EmployeeNameComponent from "./EmployeeNameComponent";
import SignBox from "./SignerBox";

const PDFSignerESignature = ({ data, documentType }) => {
  const hasApproved =
    documentType === "purchase_order"
      ? true
      : data?.employee_activity?.approved_data?.filter(
          (user) => user.approval_status === "APPROVED"
        )?.length > 0;

  const sortedApproved =
    data?.employee_activity?.approved_data
      ?.filter((user) => user.approval_status === "APPROVED")
      ?.sort((a, b) => a.step_number - b.step_number) || [];

  const filledApproved =
    documentType === "purchase_order" ? [...sortedApproved] : sortedApproved;

  while (documentType === "purchase_order" && filledApproved.length < 2) {
    filledApproved.push({});
  }

  const { created_by, created_date } =
    data.employee_activity?.created_data ?? {};

  const isSalesAndPurchase = [
    "quotation",
    "sales_order",
    "purchase_request",
    "purchase_order",
  ].includes(documentType);

  const isDelivery = ["delivery_order", "delivery_trip"].includes(documentType);

  const isShowAuditorSignature = ["quotation", "sales_order"].includes(
    documentType
  );

  return (
    <>
      <Box
        sx={{
          display: "flex",
          gap: "2rem",
          flexWrap: "nowrap",
          width: "197.3mm",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: ".5rem",
          }}
        >
          <QRCodeSVG value={window.location.href} size={72} />
          <Typography sx={{ fontSize: 12 }}>สแกนดูเอกสารออนไลน์</Typography>
        </Box>
        <SignBox
          text="ผู้ออกเอกสาร"
          created_by={created_by}
          created_date={created_date}
        />
        {isSalesAndPurchase ? (
          <>
            {documentType !== "purchase_order" && (
              <SignBox
                text="ผู้ตรวจสอบ"
                created_by={isShowAuditorSignature ? created_by : null}
                created_date={isShowAuditorSignature ? created_date : null}
              />
            )}
            {hasApproved ? (
              <>
                {filledApproved.map((employee, index) => (
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: 12,
                        fontWeight: 600,
                        mb:
                          employee?.approved_by?.has_e_signature &&
                          employee?.approved_by?.e_signature_img_url
                            ? 0
                            : 6.5,
                      }}
                    >
                      {documentType === "purchase_order" && index === 0
                        ? "ผู้ตรวจสอบ"
                        : "ผู้อนุมัติ"}
                    </Typography>
                    {employee?.approved_by?.has_e_signature &&
                      employee?.approved_by?.e_signature_img_url && (
                        <img
                          alt={employee?.approved_by?.e_signature_img_url}
                          src={employee?.approved_by?.e_signature_img_url}
                          style={{
                            display: "block",
                            marginTop: "8px",
                            width: 90,
                            height: 45,
                            objectFit: "contain",
                          }}
                        />
                      )}
                    <EmployeeNameComponent employee={employee.approved_by} />
                    <DateWithUnderline created_date={employee.created_date} />
                  </Box>
                ))}
              </>
            ) : (
              <SignBox
                text="ผู้อนุมัติ"
                created_by={null}
                created_date={null}
              />
            )}
          </>
        ) : isDelivery ? (
          <>
            <SignBox text="สโตร์" created_by={null} created_date={null} />
            <SignBox text="จัดส่ง" created_by={null} created_date={null} />
          </>
        ) : null}
      </Box>
    </>
  );
};

export default PDFSignerESignature;
